import { toast } from '@approvalmax/ui/src/components';
import { useAtom } from 'jotai';
import { useCallback, useMemo } from 'react';
import { useGetReportSchedule } from 'shared/data/webApp/v1';
import { useUpdateReportSchedule } from 'shared/data/webApp/v1';

import { messages } from './ReportSchedulerPopup.messages';
import { getReportScheduleData, getReportScheduleTransfer } from './ReportSchedulerPopup.selectors';
import { reportSchedulerOpenState } from './ReportSchedulerPopup.states';
import { ReportSchedule, ReportSchedulerPopupProps } from './ReportSchedulerPopup.types';

export const useReportSchedulerPopup = (reportConfig: ReportSchedulerPopupProps['reportConfig']) => {
    const [isOpen, handleOpenToggle] = useAtom(reportSchedulerOpenState);

    const params = { reportId: reportConfig.id, companyId: reportConfig.companyId, type: reportConfig.reportCode };

    const { data: reportSchedule } = useGetReportSchedule({ query: params }, { enabled: isOpen });
    const { mutateAsync: updateReportSchedule } = useUpdateReportSchedule();

    const schedules = useMemo(
        () => reportSchedule && getReportScheduleData(reportSchedule?.schedules, reportConfig.id),
        [reportConfig.id, reportSchedule]
    );

    const handleSave = useCallback(
        async (reportSchedule: ReportSchedule) => {
            if (!reportConfig.reportCode) {
                return;
            }

            try {
                await updateReportSchedule({
                    body: getReportScheduleTransfer(reportSchedule, reportConfig.companyId, reportConfig.reportCode),
                });

                toast.success(messages.toastUpdateSuccess);
            } catch {
                toast.error(messages.toastUpdateError);
            }

            handleOpenToggle(false);
        },
        [handleOpenToggle, updateReportSchedule, reportConfig.companyId, reportConfig.reportCode]
    );

    return {
        isOpen,
        schedules,
        handleSave,
        handleOpenToggle,
    };
};
